module.exports = __webpack_public_path__ + "static/academy_logow.4e185ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/academy_logow.png
// module id = 3027
// module chunks = 246501157640856